// import Contact from './Contact';

export default {
  // component: Contact,
  component: load(() => import(/* webpackChunkName: "Evaluation360-Contact" */ './Contact')),
  permissions: ["360EvaluationMenu/SettingMenu/ContactsMenu"],
  name: app.translate('routes.home.evaluation-360.Contact'),
  icon: 'contacts',
  drawer: true,
};
